import React from 'react'
import { useForm } from "react-hook-form";
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";

import Button from '@/components/Button'

export default function SettingsOffer() {

  return (
    <div className="grid gap-6">
      <WelcomeOffer />
      <BonusDrop />
    </div>
  )
}

const WelcomeOffer = () => {
  const schema = yup.object().shape({
    code: yup.string().min(6).required()
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      code: ''
    }
  });

  const onSubmitHandler = data => {
    console.log(data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="border border-gray-800 rounded">
      <div className="px-4">
        <div className="py-4 border-b border-gray-800">
          <div className="mb-2">
            <h2 className="font-medium text-xl">Welcome Offer</h2>
          </div>
          <p className="text-gray-300">Welcome offers are only valid for first 24 hours after signing up.</p>
        </div>
        <div className="py-3 grid gap-4">
          <div className="lg:max-w-[50%]">
            <label className="mb-1 block font-medium text-gray-300">Code</label>
            <input {...register('code')} type="text" className={errors?.code ? '!border-red-500' : ''} />
          </div>
        </div>
      </div>
      <div className="bg-gray-800 bg-opacity-50 border-t border-gray-800 px-4 py-3 flex justify-end">
        <Button type="submit" className="py-2.5 px-4">Save</Button>
      </div>
    </form>
  )
}

const BonusDrop = () => {
  const schema = yup.object().shape({
    code: yup.string().min(6).required()
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      code: ''
    }
  });

  const onSubmitHandler = data => {
    console.log(data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="border border-gray-800 rounded">
      <div className="px-4">
        <div className="py-4 border-b border-gray-800">
          <div className="mb-2">
            <h2 className="font-medium text-xl">Redeem Bonus Drop</h2>
          </div>
          <p className="text-gray-300">Find bonus drop codes on our social media's such as Twitter & Telegram.</p>
        </div>
        <div className="py-3 grid gap-4">
          <div className="lg:max-w-[50%]">
            <label className="mb-1 block font-medium text-gray-300">Code</label>
            <input {...register('code')} type="text" className={errors?.code ? '!border-red-500' : ''} />
          </div>
        </div>
      </div>
      <div className="bg-gray-800 bg-opacity-50 border-t border-gray-800 px-4 py-3 flex justify-end">
        <Button modifier="secondary" rounded="rounded-full" type="submit" className="py-2.5 px-4">Save</Button>
      </div>
    </form>
  )
}